export default "__VITE_ASSET__DY_F6pAz__"